var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartMask5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3129.1 2778.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\xA0 \xA0 \xA0 .st0 {\n\xA0 \xA0 \xA0 \xA0 fill: #fff;\n\xA0 \xA0 \xA0 }\n\xA0 \xA0 "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1491.2,236.3c26.6,26.9,51.2,56.6,73.2,87.4,90.7-124,218.5-220.5,363.3-273,382-138.6,833.5,15.7,1051.1,355.9,127.6,199.4,184.3,484,129.5,715.5-96.8,408.8-449.8,807.8-757.4,1079.9-245.3,216.9-515.5,405.3-794.5,576.1-277.9-173-548.3-360.4-793.1-578.2C456.2,1926.8,103.8,1523.3,16.6,1111.3c-50.5-238.7,17.4-534.6,156.9-733.6C470-45.2,1117.1-141.9,1491.2,236.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartMask5);
export default __webpack_public_path__ + "static/media/heart_mask5.47f5df9437490f6bf315038ac8372a0f.svg";
export { ForwardRef as ReactComponent };